import { Type } from 'class-transformer';
import {
  ArrayNotEmpty,
  Equals,
  IsArray,
  IsBoolean,
  IsIn,
  ValidateNested,
} from 'class-validator';

import { BaseRule } from './base-rule';
import { FilterType } from './consts';

export enum FunctionalGroupPosition {
  ALL = 'ALL',
  PRODUCTS = 'PRODUCTS',
  REACTANTS = 'REACTANTS',
}
const FUNCTIONAL_GROUP_POSITIONS_KEYS = Object.keys(FunctionalGroupPosition);

export enum FunctionalGroupReactionCenter {
  WITHIN = 'WITHIN',
  OUTSIDE = 'OUTSIDE',
  ANY = 'ANY',
}
const FUNCTIONAL_GROUP_REACTION_CENTER_KEYS = Object.keys(
  FunctionalGroupReactionCenter
);
export class FunctionalGroupRuleValue {
  @IsArray()
  @ArrayNotEmpty()
  @Type(() => String)
  smarts!: string[];

  @IsBoolean()
  include!: boolean;

  @IsIn(FUNCTIONAL_GROUP_POSITIONS_KEYS)
  position!: FunctionalGroupPosition;

  @IsIn(FUNCTIONAL_GROUP_REACTION_CENTER_KEYS)
  reactionCenter!: FunctionalGroupReactionCenter;
}

export class FunctionalGroupRule extends BaseRule {
  constructor() {
    super();
    this.type = FilterType.FUNCTIONAL_GROUP;
    this.value = {
      smarts: [],
      include: true,
      position: FunctionalGroupPosition.ALL,
      reactionCenter: FunctionalGroupReactionCenter.ANY,
    };
  }

  @Equals(FilterType.FUNCTIONAL_GROUP)
  type: FilterType.FUNCTIONAL_GROUP;

  @ValidateNested()
  @Type(() => FunctionalGroupRuleValue)
  value: FunctionalGroupRuleValue;
}
